import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { IoClose } from "react-icons/io5";
import PlanoLoaderModal from "./PlanoLoaderModal";
import "./styles.css";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const PlanoModal = ({
  open,
  setOpen,
  title,
  size,
  showHeader = true,
  showFooter = true,
  children,
  loader = false,
  setLoader = () => {},
  loaderText = "",
}) => {
  return (
    <BootstrapDialog
      onClose={() => {
        setOpen(false);
      }}
      open={open}
      fullWidth
      maxWidth={size ? size : "lg"}>
      <DialogTitle sx={{ m: 0, p: 2, display: showHeader ? "" : "none" }}>
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => {
          setOpen(false);
        }}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
          display: showHeader ? "" : "none",
        }}>
        <IoClose />
      </IconButton>
      <DialogContent dividers>{children}</DialogContent>
      <DialogActions
        sx={{
          display: showFooter ? "" : "none",
        }}>
        <Button
          autoFocus
          onClick={() => {
            setOpen(false);
          }}
          className="closeButtonInPlanoModal">
          Close
        </Button>
      </DialogActions>
      <PlanoLoaderModal text={loaderText} open={loader} setOpen={setLoader} />
    </BootstrapDialog>
  );
};

export default PlanoModal;
